import { apiClient, ApiClientError } from './api-client';

import type { LoginRequest, LoginResponse } from '@/types/auth.types';

export const authService = {
  async login(credentials: LoginRequest): Promise<LoginResponse> {
    const response = await fetch('/api/auth/login', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Locale': localStorage.getItem('locale') ?? 'uz',
      },
      body: JSON.stringify(credentials),
    });

    if (!response.ok) {
      const body: unknown = await response.json().catch(() => null);
      const bodyObj = body as Record<string, unknown> | null;
      const message =
        typeof bodyObj?.['message'] === 'string' ? bodyObj['message'] : response.statusText;

      throw new ApiClientError(message, response.status, body);
    }

    return response.json() as Promise<LoginResponse>;
  },

  async refresh(refreshToken: string): Promise<LoginResponse> {
    const response = await fetch('/api/auth/refresh', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Locale': localStorage.getItem('locale') ?? 'uz',
      },
      body: JSON.stringify({ refreshToken }),
    });

    if (!response.ok) {
      const body: unknown = await response.json().catch(() => null);
      const bodyObj = body as Record<string, unknown> | null;
      const message =
        typeof bodyObj?.['message'] === 'string' ? bodyObj['message'] : response.statusText;

      throw new ApiClientError(message, response.status, body);
    }

    return response.json() as Promise<LoginResponse>;
  },

  fetchMe() {
    return apiClient.get<LoginResponse['user']>('/auth/me');
  },

  logout() {
    return apiClient.post<undefined>('/auth/logout');
  },
};
